var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import CheckApply from "~/components/visit-case/check-apply.vue";
import { Dependencies } from "~/core/decorator";
import { FlowTaskService } from "~/services/domain-service/flow-task.service";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
import { ApplyType } from "~/config/enum.config";
var PauseApply = /** @class */ (function (_super) {
    __extends(PauseApply, _super);
    function PauseApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            applyDescription: '',
            pauseDueTime: ''
        };
        _this.checkMessages = {};
        _this.rules = {
            applyDescription: { required: true, message: "请输入申请原因" },
            pauseDueTime: { required: true, message: "请选择停催到期日期" },
        };
        _this.submitLoading = false;
        _this.dialog = false;
        return _this;
    }
    PauseApply.prototype.emitClose = function () {
        this.resetDate();
    };
    PauseApply.prototype.pauseDueTimeChange = function () {
        var currentDay = new Date(this.dataForm.pauseDueTime);
        var nextDay = new Date();
        if (nextDay.getDate() > this.perDueDate) {
            nextDay.setMonth(nextDay.getMonth() + 1);
        }
        nextDay.setDate(this.perDueDate);
        if (currentDay > nextDay) {
            this.$message.warning("当前选择日期超过下个账单日");
        }
    };
    /**
     * 提交
     */
    PauseApply.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["dataFrom"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            _this.commitNext();
        });
    };
    /**
     * 检查案件
     */
    PauseApply.prototype.commitNext = function () {
        var _this = this;
        this.flowTaskService
            .checkApplyCategory({ applyCategory: this.applyType })
            .subscribe(function (data) {
            // 0 拒绝，1 提示，2 通过
            if (data.status === 1) {
                _this.$confirm("该" +
                    _this.$dict.getDictName(_this.applyType, "ApplyCategory") +
                    "申请将直接生效，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(function () {
                    _this.submit();
                })
                    .catch(_this.error);
            }
            else if (data.status === 2) {
                _this.submit();
            }
        }, this.error);
    };
    /**
     * 提交接口调用
     */
    PauseApply.prototype.submit = function () {
        this.submitLoading = true;
        this.dataForm.caseIds = this.caseIds;
        this.dataForm.applyCategory = this.applyType;
        if (this.applyType === ApplyType.pause.value) {
            this.pause();
        }
        else {
            this.active();
        }
    };
    /**
     * 暂停催收
     */
    PauseApply.prototype.pause = function () {
        this.dataForm.pauseDueTime = this.$filter.dateEndFormat(this.dataForm.pauseDueTime);
        var requestModel = this.dataForm;
        if (this.otherData) {
            requestModel = __assign(__assign({}, this.dataForm), this.otherData);
        }
        this.caseApplyRecordService
            .applyPauseCase(requestModel)
            .subscribe(this.success, this.error);
    };
    /**
     * 停催激活
     */
    PauseApply.prototype.active = function () {
        this.caseApplyRecordService
            .applyPauseCaseActive(this.dataForm)
            .subscribe(this.success, this.error);
    };
    /**
     * 申请成功
     */
    PauseApply.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.emitClose();
        }
    };
    /**
     * 失败
     */
    PauseApply.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 取消
     */
    PauseApply.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 继续提交
     */
    PauseApply.prototype.confirmSubmit = function () {
        this.dataForm.confirm = 1;
        this.submit();
    };
    /**
     * 数据重置
     */
    PauseApply.prototype.resetDate = function () {
        this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            applyDescription: '',
            pauseDueTime: ''
        };
        var form = this.$refs["dataFrom"];
        form.resetFields();
        this.checkMessages = {};
    };
    __decorate([
        Dependencies(FlowTaskService)
    ], PauseApply.prototype, "flowTaskService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], PauseApply.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop({ type: String })
    ], PauseApply.prototype, "applyType", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], PauseApply.prototype, "caseIds", void 0);
    __decorate([
        Prop({ type: Object })
    ], PauseApply.prototype, "otherData", void 0);
    __decorate([
        Emit('close')
    ], PauseApply.prototype, "emitClose", null);
    PauseApply = __decorate([
        Component({
            components: {
                CheckApply: CheckApply,
            }
        })
    ], PauseApply);
    return PauseApply;
}(Vue));
export default PauseApply;
